import { create } from 'zustand';
import { getDemoData } from '../api/generated/demo-data/demo-data';
import { useToastStore } from './useToastStore';
import { showApiError } from '../errors';
import i18n from '@/i18n/config';

const { postApiV1DemoDataRefresh, postApiV1DemoDataReset } = getDemoData();

export type DemoDataAction = 'refresh' | 'reset';

interface AdminDemoDataState {
  running: DemoDataAction | null;
  run: (action: DemoDataAction) => Promise<boolean>;
}

const calls: Record<DemoDataAction, () => Promise<void>> = {
  refresh: () => postApiV1DemoDataRefresh(),
  reset: () => postApiV1DemoDataReset(),
};

export const useAdminDemoDataStore = create<AdminDemoDataState>((set, get) => ({
  running: null,

  run: async (action) => {
    if (get().running) return false;
    set({ running: action });
    try {
      await calls[action]();
      useToastStore
        .getState()
        .addToast(i18n.t(`admin:demoData.${action}.success`), 'success');
      return true;
    } catch (error) {
      showApiError(error);
      return false;
    } finally {
      set({ running: null });
    }
  },
}));
